import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

const TopCollege = () => {
    const { id } = useParams(); 
    const navigate = useNavigate();
    console.log('id' , id);
    const [countries, setCountries] = useState([
        {
            country: "",
            courseDuration: "",
            averageFees: "",
            universities: [{ name: "", website: "" }]
        }
    ]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [saveSuccess, setSaveSuccess] = useState("");
    const [saveError, setSaveError] = useState("");

    useEffect(() => {
        if (id) {
            fetchTopCollegeData(id);
        }
    }, [id]);

    const fetchTopCollegeData = async (careerId) => {
        setLoading(true);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_KEY}career/fetchTopCollege`,
                new URLSearchParams({
                    career_id: careerId
                }),
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }
            );
    
            console.log("API Response: ", response); // Log to verify structure
    
            if (response.data && response.data.success) {
                const fetchedData = response.data.data;
    
                // If the API returns null, set default data
                if (fetchedData && Array.isArray(fetchedData) && fetchedData.length > 0) {
                    const fetchedCountries = fetchedData.map(college => ({
                        id: college.id,
                        country: college.country,
                        courseDuration: college.course_duration,
                        averageFees: college.average_fees,
                        universities: college.university_name.split('#').map((name, index) => ({
                            name,
                            website: college.university_website.split('#')[index] || ''
                        }))
                    }));
                    setCountries(fetchedCountries);
                } else {
                    // No data or null, set default entry
                    setCountries([
                        {
                            country: "",
                            courseDuration: "",
                            averageFees: "",
                            universities: [{ name: "", website: "" }]
                        }
                    ]);
                }
            } else {
                setError("Failed to fetch college data.");
            }
        } catch (err) {
            console.error("Error fetching data: ", err);
            setError("Error fetching college data.");
        } finally {
            setLoading(false);
        }
    };
    
    

    const handleAddCountry = () => {
        if (countries.length < 4) {
            setCountries([
                ...countries,
                {
                    country: "",
                    courseDuration: "",
                    averageFees: "",
                    universities: [{ name: "", website: "" }]
                }
            ]);
        }
    };

    const handleRemoveCountry = async (index) => {
        const countryData = countries[index];
    
        if (countryData.id) {
            try {
                const formData = new URLSearchParams();
                formData.append('id', countryData.id);
    
                const response = await axios.post(`${process.env.REACT_APP_API_KEY}career/removeTopCollege`, formData, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Cookie': ''
                    }
                });
    
                if (response.data.success) {
                    const newCountries = countries.filter((_, i) => i !== index);
                    setCountries(newCountries);
                    setSaveSuccess("Country removed successfully.");
                } else {
                    setSaveError("Failed to remove the country.");
                }
            } catch (error) {
                console.error("Error removing country: ", error);
                setSaveError("Error occurred while removing the country.");
            }
        } else {
            // If no ID is present, just remove the country from the UI
            const newCountries = countries.filter((_, i) => i !== index);
            setCountries(newCountries);
        }
    };
    

    const handleCountryChange = (index, field, value) => {
        const newCountries = countries.map((country, i) => {
            if (i === index) {
                return { ...country, [field]: value };
            }
            return country;
        });
        setCountries(newCountries);
    };

    const handleUniversityChange = (countryIndex, uniIndex, field, value) => {
        const newCountries = countries.map((country, i) => {
            if (i === countryIndex) {
                const newUniversities = country.universities.map((university, j) => {
                    if (j === uniIndex) {
                        return { ...university, [field]: value };
                    }
                    return university;
                });
                return { ...country, universities: newUniversities };
            }
            return country;
        });
        setCountries(newCountries);
    };

    const handleAddUniversity = (countryIndex) => {
        const newCountries = countries.map((country, i) => {
            if (i === countryIndex && country.universities.length < 4) {
                return {
                    ...country,
                    universities: [...country.universities, { name: "", website: "" }]
                };
            }
            return country;
        });
        setCountries(newCountries);
    };

    const handleRemoveUniversity = (countryIndex, uniIndex) => {
        const newCountries = countries.map((country, i) => {
            if (i === countryIndex) {
                const newUniversities = country.universities.filter((_, j) => j !== uniIndex);
                return { ...country, universities: newUniversities };
            }
            return country;
        });
        setCountries(newCountries);
    };

    const handleSave = async () => {
        setSaveSuccess("");
        setSaveError(""); 
    
        for (let countryData of countries) {
            const universityNames = countryData.universities.map(u => u.name).join("#");
            const universityWebsites = countryData.universities.map(u => u.website).join("#");
    
            const formData = new URLSearchParams();
            formData.append('career_id', id);
            formData.append('country', countryData.country);
            formData.append('course_duration', countryData.courseDuration);
            formData.append('average_fees', countryData.averageFees);
            formData.append('university_name', universityNames);
            formData.append('university_website', universityWebsites);
    
            if (countryData.id) {
                formData.append('isEdit', 1);
                formData.append('id', countryData.id);  // Use the id from the API response
            } else {
                formData.append('isEdit', 0);
                formData.append('id', 0);  // If no id is present, use 0
            }
    
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_KEY}career/topCollege`, formData, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Cookie': ''
                    }
                });
                console.log(`Response for ${countryData.country}: `, response.data);
    
                // Show success message after save
                setSaveSuccess("Data saved successfully!");
                window.location.href = `/career-deep-dive/${id}?tab=prospects`;
            } catch (error) {
                console.error(`Error for ${countryData.country}: `, error);
                
                // Show error message after failure
                setSaveError("Error saving data, please try again.");
            }
        }
    };
    

    const handleCancel = () => {
        navigate("/career-list");
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;

    return (
        <div className="bg-white radius-10 p-4 p-sm-5 shadow">
            {countries.map((countryData, countryIndex) => (
                <div key={countryIndex} className="mb-4">
                    <div className="row g-4">
                        <div className="col-md-12 d-flex justify-content-between align-items-center">
                            <h2 className="fw-semibold font-24">Top College List - Country {countryIndex + 1}</h2>
                            {countries.length > 1 && (
                                <button
                                    type="button"
                                    className="btn btn-danger height-45"
                                    onClick={() => handleRemoveCountry(countryIndex)}
                                >
                                    Remove Country
                                </button>
                            )}
                        </div>

                        <div className="col-md-6">
                            <label htmlFor={`country-${countryIndex}`} className="form-label w-100 font-500 mb-1">Country </label>
                            <select
                                id={`country-${countryIndex}`}
                                className="form-select height-45"
                                value={countryData.country}
                                onChange={(e) => handleCountryChange(countryIndex, 'country', e.target.value)}
                            >
                                <option value="">Select</option>
                                <option value="India">India</option>
                                <option value="USA">USA</option>
                                <option value="UK">UK</option>
                                <option value="Canada">Canada</option>
                                <option value="Australia">Australia</option>
                            </select>
                        </div>

                        <div className="col-md-6">
                            <label htmlFor={`courseDuration-${countryIndex}`} className="form-label w-100 font-500 mb-1">Course Duration </label>
                            <input
                                id={`courseDuration-${countryIndex}`}
                                type="text"
                                className="form-control height-45"
                                placeholder="Ex: 3 Yrs"
                                maxLength="50"
                                value={countryData.courseDuration}
                                onChange={(e) => handleCountryChange(countryIndex, 'courseDuration', e.target.value)}
                            />
                        </div>

                        <div className="col-md-6">
                            <label htmlFor={`averageFees-${countryIndex}`} className="form-label w-100 font-500 mb-1">Average Fees </label>
                            <input
                                id={`averageFees-${countryIndex}`}
                                type="text"
                                className="form-control height-45"
                                placeholder="Ex: 10,00,000"
                                maxLength="50"
                                value={countryData.averageFees}
                                onChange={(e) => handleCountryChange(countryIndex, 'averageFees', e.target.value)}
                            />
                        </div>

                        <div className="col-12">
                            <div className="p-4 bg-light bg-gradient radius-6 mb-3">
                                <div className="row g-3">
                                    {countryData.universities.map((university, uniIndex) => (
                                        <React.Fragment key={uniIndex}>
                                            <div className="col-md-5">
                                                <label htmlFor={`universityName-${countryIndex}-${uniIndex}`} className="form-label w-100 font-500 mb-1">University Name </label>
                                                <input
                                                    id={`universityName-${countryIndex}-${uniIndex}`}
                                                    type="text"
                                                    className="form-control height-45"
                                                    placeholder="Ex: BITS Pilani"
                                                    maxLength="50"
                                                    value={university.name}
                                                    onChange={(e) => handleUniversityChange(countryIndex, uniIndex, 'name', e.target.value)}
                                                />
                                            </div>
                                            <div className="col-md-5">
                                                <label htmlFor={`universityWebsite-${countryIndex}-${uniIndex}`} className="form-label w-100 font-500 mb-1">University Website </label>
                                                <input
                                                    id={`universityWebsite-${countryIndex}-${uniIndex}`}
                                                    type="text"
                                                    className="form-control height-45"
                                                    placeholder="Ex: https://www.bits-pilani.ac.in/"
                                                    maxLength="50"
                                                    value={university.website}
                                                    onChange={(e) => handleUniversityChange(countryIndex, uniIndex, 'website', e.target.value)}
                                                />
                                            </div>
                                            <div className="col-md-2 d-flex align-items-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-danger height-45"
                                                    onClick={() => handleRemoveUniversity(countryIndex, uniIndex)}
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>
                            {countryData.universities.length < 4 && (
                                <button className="btn-green pe-3" onClick={() => handleAddUniversity(countryIndex)}>
                                    <i className="icon-plus me-2"></i> Add More Universities
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            ))}
            {countries.length < 4 && (
                <div className="col-12">
                    <button className="btn-green pe-3" onClick={handleAddCountry}>
                        <i className="icon-plus me-2"></i> Add More Country
                    </button>
                </div>
            )}

            <div className="col-md-12">
                <div className="action_btns mt-3">
                    <div className="row g-2 align-items-center justify-content-center">
                        <div className="col-auto">
                            <button type="button" className="btn btn-green height-45 px-4" onClick={handleSave}>
                                <span>Save and Next</span>
                            </button>
                        </div>
                        <div className="col-auto">
                            <button type="button" className="btn btn-border-gray height-45 px-5" onClick={handleCancel}>
                                <span>Cancel </span>
                            </button>
                        </div>
                    </div>
                </div>
                {saveSuccess && <div className="alert alert-success mt-3">{saveSuccess}</div>}
                {saveError && <div className="alert alert-danger mt-3">{saveError}</div>}
            </div>
        </div>
    );
};

export default TopCollege;
